import * as React from 'react';
import { PieChart, pieArcLabelClasses  } from '@mui/x-charts/PieChart';
import { Button, TextField, Autocomplete, Typography, Box, Grid, Stack, debounce, IconButton } from '@mui/material';
import SoilCompositionSearch from './SoilCompositionSearch';
import { Delete } from '@mui/icons-material';

const defaultSoilComposition = [
    
    { id: 0, value: 1, label: 'Akadama' },
    { id: 1, value: 1, label: 'Pumice' },
    { id: 2, value: 2, label: 'Pine Bark' },
];

function arcLabel(label) {
    // abreviate to 4 characters
    return label.substring(0, 4);
}

export default function BonsaiSoilComposition({ substrates = [], setSoilComposition, soilComposition = defaultSoilComposition, comment, setComment }) {
  
    const handleIncrement = (id) => {
        let newData = soilComposition.map((item) =>
            item.id === id ? { ...item, value: item.value + 1 } : item
        );
        setSoilComposition(newData);
    };

    const handleDecrement = (id) => {
        let newData = soilComposition.map((item) =>
            item.id === id ? { ...item, value: item.value - 1 } : item
        );
        setSoilComposition(newData);
    };

    const handleAddElement = (name, value) => {
        // check if element already exists
        const existingElement = soilComposition.find((item) => item.label === name);
        // if exists then alert user
        if (existingElement) {
            alert('Element already exists. If you want to add more then use the incrementer.');
            return;
        }
        const newElement = {
            id: soilComposition.length,
            value: parseInt(value),
            label: name,
        };
        setSoilComposition([...soilComposition, newElement]);
    };

    const handleRemoveElement = (id) => {
        const newElements = soilComposition.filter((item) => item.id !== id);
        setSoilComposition(newElements);
    };
    React.useEffect(() => {
        const handleResize = debounce(() => {
        }, 200);
        
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }
    , []);


    return (
        <Box>            
        <Typography variant="h5" style={{ marginBottom: "1rem" }}>
        Soil Composition
        </Typography>
            <Typography variant="body1" gutterBottom
            style={{ marginBottom: '1rem' }}
            >
                What soil composition do you use for your bonsai?
            </Typography>
            <Grid container spacing={2}>
                
            <Grid item xs={12} sm={6}>
            {soilComposition.map((item) => (
                <Stack key={item.id}
                    spacing={2}
                    direction="row"
                >
                    <span style={{width:100, alignContent:"center"}}>{item.label}: </span>
                    <Button onClick={() => handleDecrement(item.id)}>-</Button>
                    <span style={{alignContent:"center"}}>{item.value}</span>
                    <Button onClick={() => handleIncrement(item.id)}>+</Button>
                    {/* <Button onClick={() => handleRemoveElement(item.id)}>Remove</Button> */}
                    {/* Button to delete, if xs then how delete icon instead of word */}
                    <IconButton
                        onClick={() => handleRemoveElement(item.id)}
                    >
                        <Delete/>
                    </IconButton>
                    {/* <Button
                        onClick={() => handleRemoveElement(item.id)}
                    >
                        Remove
                    </Button> */}

                </Stack>
            ))}
            
            <Stack direction="row"spacing={2}
                style={{ marginTop: '1rem',
                    marginBottom: '1rem'

                 }}
            >
                <SoilCompositionSearch
                    onSelect={(newValue) => handleAddElement(newValue, 1)}
                    substrates={substrates}
                />


                {/* <Autocomplete
                style={{ width: 300 }}
                    options={substrates}
                    getOptionLabel={(option) => option}
                    
                            id="substrateInput"
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            type="text"
                            placeholder="Substrate"
                            id="substrateInput"
                        />
                    )}
                /> */}
                {/* <Button
                    onClick={() =>
                        handleAddElement(
                            document.getElementById('substrateInput').value,
                            1
                        )
                    }
                >
                    Add
                </Button> */}
            </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
                    
            <PieChart skipAnimation series={[{ 
                    arcLabel: (item) =>arcLabel(item.label),
                    arcLabelMinAngle: 45,
                data: soilComposition }]} width={400} height={200}
                
  slotProps={{ legend: { hidden: true } }}
  sx={{
    [`& .${pieArcLabelClasses.root}`]: {
      fill: 'white',
    //   fontWeight: 'bold',
    },
  }}
            />
            </Grid>
            </Grid>

            {/* Textbox to enter comments about the soil compostion */}
            <Typography variant="h6">Provide some details on the soil composition</Typography>
            <TextField
            // lines
                    rows={4}
                multiline
                fullWidth
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter your comments here"
            />
        </Box>
    );
}
